package team.platforma.multiplatform_material_extension.ui.email

class EmailInputMessages {
    var onFieldClear = "Обязательное поле"
    var enInputMessage = "example@mail.com"
    var ruInputMessage = "пример@мейл.ру"
}